"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameserviceSchema = exports.vendorFieldSchema = exports.amountSchema = void 0;
exports.amountSchema = { bignumber: { minimum: 0, maximum: 0 } };
exports.vendorFieldSchema = { anyOf: [{ type: "null" }, { type: "string", format: "vendorField" }] };
exports.nameserviceSchema = {
    type: "object",
    required: ["name"],
    properties: {
        name: {
            type: "string",
            minLength: 1,
            maxLength: 90,
            pattern: "^[a-zA-Z0-9]+(( - |[ ._-])[a-zA-Z0-9]+)*[.]?$",
        },
    },
};
//# sourceMappingURL=nameservice-schemas.js.map